import { atom } from 'jotai';

const acceptedSuggestions = atom();

export { acceptedSuggestions };